export default {"src":"/_next/static/media/de.87c619c2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};